import * as types from '../constants/ActionTypes';
import {append, without} from 'ramda';


const INITIAL_STATE = {
    isLoading: false,
    requests: [],
};

export default function loadingStateReducer(state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.REQUEST_PENDING:
            return {
                isLoading: true,
                requests: append(action.payload, state.requests)
            };

        case types.REQUEST_COMPLETE:
            const remainingRequests = without(action.payload, state.requests);
            // @TODO we need a refernce to if there was an error to return false for isLoading

            // console.log('loadingStateReducer COMPLETE ', {
            //   action: action.payload,
            //   isLoading: remainingRequests.length > 0,
            //   requests: remainingRequests,
            // });
            return {
                isLoading: remainingRequests.length > 0,
                requests: remainingRequests,
            };

        default:
            return state;
    }

};
